module.exports = __webpack_public_path__ + "static/media/cert_57.e0997608.jpg";